import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Select from 'react-select';

const ChangePlayerModal = ({ show, onHide, playerType, players, onPlayerSelect }) => {
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    
    const playerOptions = players.map(p => ({ value: p.id, label: p.player_name, player: p }));

    const handleSelect = () => {
        if (selectedPlayer) {
            onPlayerSelect(selectedPlayer.player);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton><Modal.Title>Change {playerType}</Modal.Title></Modal.Header>
            <Modal.Body>
                <p>Select the new {playerType}.</p>
                <Select
                    options={playerOptions}
                    onChange={setSelectedPlayer}
                    placeholder={`Select new ${playerType}...`}
                />
            </Modal.Body>
            <Modal.Footer><Button variant="secondary" onClick={onHide}>Cancel</Button><Button variant="primary" onClick={handleSelect}>Confirm Change</Button></Modal.Footer>
        </Modal>
    );
};

export default ChangePlayerModal;
